export default __webpack_public_path__ + "static/media/GreenFrame01.8be02ded.png";